import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { updateSpaceAsync } from '../../../../Manage/actions'
import styles from './SpaceActions.module.css'

const SpaceActions = ({ spaceId, spaceName, onEditSpace, onDeleteSpace }) => {
  const dispatch = useDispatch()
  const space = useSelector((state) => state.manage.spaces.find((s) => String(s.id) === String(spaceId)))
  const isPrivate = Boolean(space?.isPrivate)
  const hasTeam = useSelector((state) => (state.manage.members || []).length > 0)

  const handleEdit = (e) => {
    e.stopPropagation()
    onEditSpace(spaceId, spaceName)
  }

  const handleDelete = (e) => {
    e.stopPropagation()
    onDeleteSpace(spaceId, spaceName)
  }

  const handleTogglePrivacy = (e) => {
    e.stopPropagation()
    dispatch(updateSpaceAsync(spaceId, { isPrivate: !isPrivate })).catch(() => {})
  }

  return (
    <Dropdown className={styles.spaceActions} onClick={(e) => e.stopPropagation()}>
      <Dropdown.Toggle variant="link" className={styles.gearButton} id={`space-actions-${spaceId}`}>
        <img src="/assets/icons/setting-black.svg" alt="Space options" />
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.dropdownMenu}>
        <Dropdown.Item onClick={handleEdit} className={styles.dropdownItem}>
          <img src="/assets/icons/edit.svg" alt="" />
          <span>Rename</span>
        </Dropdown.Item>
        {space && (hasTeam || isPrivate) && (
          <Dropdown.Item onClick={handleTogglePrivacy} className={styles.dropdownItem}>
            <img src={isPrivate ? '/assets/icons/lock-open.svg' : '/assets/icons/lock-closed.svg'} alt="" />
            <span>{isPrivate ? 'Make public' : 'Make private'}</span>
          </Dropdown.Item>
        )}
        <Dropdown.Item onClick={handleDelete} className={styles.dropdownItem}>
          <img src="/assets/icons/trash.svg" alt="" />
          <span>Delete</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default SpaceActions
